module.exports = __webpack_public_path__ + "img/default-nav-subnav-toyota.5efa18e3.png";